<template>
  <el-dialog :title="$t('addChainSupplier.addSupplier')" :visible.sync="dialogVisible" width="80%" @close="handleClose">
    <el-form :model="addChainSupplierInfo" :rules="rules" ref="form" label-width="150px">
      <el-form-item :label="$t('addChainSupplier.supplierName')" prop="name">
        <el-input v-model="addChainSupplierInfo.name"
          :placeholder="$t('addChainSupplier.supplierNamePlaceholder')"></el-input>
      </el-form-item>

      <el-form-item :label="$t('addChainSupplier.appId')" prop="appId">
        <el-input v-model="addChainSupplierInfo.appId"
          :placeholder="$t('addChainSupplier.appIdPlaceholder')"></el-input>
      </el-form-item>

      <el-form-item :label="$t('addChainSupplier.appSecure')" prop="appSecure">
        <el-input v-model="addChainSupplierInfo.appSecure"
          :placeholder="$t('addChainSupplier.appSecurePlaceholder')"></el-input>
      </el-form-item>

      <el-form-item :label="$t('addChainSupplier.mchId')" prop="mchId">
        <el-input v-model="addChainSupplierInfo.mchId"
          :placeholder="$t('addChainSupplier.mchIdPlaceholder')"></el-input>
      </el-form-item>

      <el-form-item :label="$t('addChainSupplier.mchKey')" prop="mchKey">
        <el-input v-model="addChainSupplierInfo.mchKey"
          :placeholder="$t('addChainSupplier.mchKeyPlaceholder')"></el-input>
      </el-form-item>

      <el-form-item :label="$t('addChainSupplier.url')" prop="url">
        <el-input v-model="addChainSupplierInfo.url" :placeholder="$t('addChainSupplier.urlPlaceholder')"></el-input>
      </el-form-item>

      <el-form-item :label="$t('addChainSupplier.beanName')" prop="beanName">
        <el-input v-model="addChainSupplierInfo.beanName"
          :placeholder="$t('addChainSupplier.beanNamePlaceholder')"></el-input>
      </el-form-item>

      <el-form-item :label="$t('addChainSupplier.suType')" prop="suType">
        <el-select v-model="addChainSupplierInfo.suType" style="width:100%">
          <el-option :value="1" :label="$t('addChainSupplier.suType1')"></el-option>
          <el-option :value="2" :label="$t('addChainSupplier.suType2')"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('addChainSupplier.remark')" prop="remark">
        <el-input type="textarea" v-model="addChainSupplierInfo.remark"
          :placeholder="$t('addChainSupplier.remarkPlaceholder')"></el-input>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="saveChainSupplierInfo">{{ $t('common.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { saveChainSupplier } from '@/api/admin/chainSupplier/chainSupplierApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'AddChainSupplier',
  props: {
    callBackListener: String,
    callBackFunction: String
  },
  data() {
    return {
      dialogVisible: false,
      addChainSupplierInfo: {
        csId: '',
        name: '',
        appId: '',
        appSecure: '',
        mchId: '',
        mchKey: '',
        url: '',
        remark: '',
        beanName: '',
        statusCd: '0',
        suType: 1,
        shopId: ''
      },
      rules: {
        name: [
          { required: true, message: this.$t('addChainSupplier.supplierNameRequired'), trigger: 'blur' },
          { max: 30, message: this.$t('addChainSupplier.supplierNameMaxLength'), trigger: 'blur' }
        ],
        appId: [
          { required: true, message: this.$t('addChainSupplier.appIdRequired'), trigger: 'blur' },
          { max: 500, message: this.$t('addChainSupplier.appIdMaxLength'), trigger: 'blur' }
        ],
        appSecure: [
          { required: true, message: this.$t('addChainSupplier.appSecureRequired'), trigger: 'blur' },
          { max: 500, message: this.$t('addChainSupplier.appSecureMaxLength'), trigger: 'blur' }
        ],
        mchId: [
          { required: true, message: this.$t('addChainSupplier.mchIdRequired'), trigger: 'blur' },
          { max: 32, message: this.$t('addChainSupplier.mchIdMaxLength'), trigger: 'blur' }
        ],
        mchKey: [
          { required: true, message: this.$t('addChainSupplier.mchKeyRequired'), trigger: 'blur' },
          { max: 128, message: this.$t('addChainSupplier.mchKeyMaxLength'), trigger: 'blur' }
        ],
        url: [
          { required: true, message: this.$t('addChainSupplier.urlRequired'), trigger: 'blur' },
          { max: 128, message: this.$t('addChainSupplier.urlMaxLength'), trigger: 'blur' }
        ],
        beanName: [
          { required: true, message: this.$t('addChainSupplier.beanNameRequired'), trigger: 'blur' },
          { max: 50, message: this.$t('addChainSupplier.beanNameMaxLength'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this.resetForm()
    },
    resetForm() {
      this.addChainSupplierInfo = {
        csId: '',
        name: '',
        appId: '',
        appSecure: '',
        mchId: '',
        mchKey: '',
        url: '',
        remark: '',
        beanName: '',
        statusCd: '0',
        suType: 1,
        shopId: getShopId()
      }
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate()
      })
    },
    async saveChainSupplierInfo() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return

        try {
          const { code, msg } = await saveChainSupplier(this.addChainSupplierInfo)
          if (code == 0) {
            this.$message.success(this.$t('common.saveSuccess'))
            this.dialogVisible = false
            this.$emit('success')
          } else {
            this.$message.error(msg)
          }
        } catch (error) {
          this.$message.error(error.message || error)
        }
      })
    },
    handleClose() {
      this.$refs.form.resetFields()
    }
  }
}
</script>

<style scoped>
.el-input,
.el-textarea {
  width: 100%;
}
</style>